// extracted by mini-css-extract-plugin
export default {"wrapper":"textOption_wrapper__pbplx","cancel":"textOption_cancel__eKc2o"};